import axios from "../utils/axios-interceptor";

export const getCodeDocumentationApi = async(payload) => {
  try {
    const res = await axios.post(`/code_documentation/?repoPath=${payload.repoPath}&language=${payload.language}`)
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}